<template>
  <div class="app-wrap">
    <Navbar v-if="theme === 'normal'" @drawer="openDrawer"></Navbar>
    <navbar-backend v-if="theme === 'black'" @drawer="openDrawer"></navbar-backend>
    <div class="main" v-ps :style="theme === 'none' ? 'height: 100vh' : ''">
      <router-view></router-view>
    </div>
    <quick-menu ref="drawer"></quick-menu>
  </div>
</template>

<script>
import Navbar from "./Navbar"
import NavbarBackend from "./NavbarBackend"
import QuickMenu from "./QuickMenu"

export default {
  name: "app-wrap",
  components: {
    QuickMenu,
    Navbar,
    NavbarBackend
  },
  data() {
    return {
      drawer: false
    }
  },
  computed: {
    theme() {
      return this.$route.matched[0].meta.theme || "normal"
    }
  },
  methods: {
    openDrawer() {
      this.$refs.drawer.openDrawer()
    }
  }
}
</script>

<style lang="scss" scoped>
.app-wrap {
  position: relative;
  height: 100%;
  width: 100%;
  background: $color-bg-home;
  overflow: hidden;
  .main {
    width: 100%;
    height: calc(100vh - #{$navbar-height});
    position: relative;
  }
}
</style>
